export default __webpack_public_path__ + "958440ab55d3ca8a857de6905c279306.svg";